import { gql } from '__generated__'

export const GetCandidateBucketAudits = gql(/* GraphQL */ `
    query GetCandidateBucketAudits($candidateId: String!) {
        candidateBucketAudits(candidateId: $candidateId) {
            id
            candidateId
            bucket
            reason
            resolvedCalendlyLink
            linkResolutionReason
            createdAt
        }
    }
`)

export const GetCandidateQuestionnaireAnswers = gql(/* GraphQL */ `
    query GetCandidateQuestionnaireAnswers($candidateId: String!) {
        candidateQuestionnaireAnswers(candidateId: $candidateId) {
            id
            questionDisplayName
            questionInternalName
            questionType
            answerData
            intakePart
            createdAt
        }
    }
`)

export const GetSchedulerDiagnostic = gql(/* GraphQL */ `
    query GetSchedulerDiagnostic($candidateId: ID) {
        candidate(id: $candidateId) {
            id
            interviewBucket {
                schedulerDiagnostic {
                    visible
                    reason
                }
            }
        }
    }
`)

export const GetCandidateBucketAuditSearch = gql(/* GraphQL */ `
    query GetCandidateBucketAuditSearch(
        $page: Int!
        $limit: Int!
        $quickSearch: String
    ) {
        candidateBucketAuditSearch(
            page: $page
            limit: $limit
            quickSearch: $quickSearch
        ) {
            rows {
                candidateId
                candidateFirstName
                candidateLastName
                bucket
                reason
                resolvedCalendlyLink
                linkResolutionReason
                createdAt
            }
            totalCount
        }
    }
`)
